!(function () {
  const GRAPHQL_ENDPOINT = `/api/2023-07/graphql.json`;

  const SEARCH_QUERY = `
    query SearchArticles($query: String!, $pageSize: Int!, $cursor: String) {
      search(query: $query, types: ARTICLE, first: $pageSize, after: $cursor) {
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          cursor
          node {
            ... on Article {
              id
              handle
              title
              excerpt
              publishedAt
              image {
                url
                altText
                width
                height
              }
            }
          }
        }
      }
    }
  `;

  function getBlogURL() {
    return document.querySelector('.kw-blog').dataset.blogUrl;
  }

  function getArticleURL(handle) {
    const tag = getTagParam();
    let url = getBlogURL() + '/' + handle;

    if (tag) {
      url += '?tag=' + tag;
    }
    return url;
  }

  function getNextCursorOrPage() {
    return document.querySelector('.kw-blog__load-more').dataset.next;
  }

  function getPageSize() {
    return parseInt(document.querySelector('.kw-blog').dataset.pageSize, 10);
  }

  function getTagParam() {
    const url = new URL(window.location.href);
    const parts = url.pathname.split('/tagged/');
    if (parts.length === 2) {
      return parts.pop();
    }
    return null;
  }

  function getQueryParam() {
    const url = new URL(window.location.href);
    return url.searchParams.get('q');
  }

  function sizedImage(src, size) {
    const parts = src.split('.jpg');
    if (parts.length !== 2) {
      return src;
    }

    return parts[0] + '_' + size + '.jpg' + parts[1];
  }

  function setImageAttributes(img, image) {
    const src = image.url;
    img.src = sizedImage(src, '533x');
    img.alt = image.altText;
    img.width = image.width;
    img.height = image.height;
    const srcsets = [];
    const sizes = [165, 360, 533, 720, 1000, 1500];

    sizes.forEach(size => {
      if (image.width >= size) {
        srcsets.push(sizedImage(src, size + 'x') + ' ' + size + 'w');
      }
    });

    srcsets.push(src + image.width + 'w');
    img.srcset = srcsets.join(',');
  }

  function truncateWords(text, maxWords) {
    const words = text.trim().split(/\s+/);

    if (words.length <= maxWords) {
      return text;
    }

    return words.slice(0, maxWords).join(' ') + '...';
  }

  function renderArticles(articles, append) {
    const wrapper = document.createElement('div');
    const html = document.querySelector('#kw-article-card-template').innerHTML;
    const articlesContainer = document.querySelector('.kw-blog__articles');

    let contentBlock = null;
    let blockIndex = 0;
    let contentPos = -1;
    let contentItems = [];

    if (!append) {
      contentItems = document.querySelectorAll('.kw-blog__content-item');
      contentItems = Array.prototype.map.call(contentItems, function (x) {
        return x.cloneNode(true);
      });
      contentBlock = contentItems[blockIndex] || null;
      contentPos = contentBlock ? parseInt(contentBlock.dataset.pos, 10) : -1;
    }

    for (let i = 0; i < articles.length; i++) {
      const article = articles[i];
      const articleWrapper = document.createElement('div');
      articleWrapper.innerHTML = html;

      const id = article.id.split('/').pop();

      articleWrapper.firstElementChild.setAttribute(
        'aria-labelledby',
        'Article-' + id
      );

      articleWrapper.querySelector('article > a').href = getArticleURL(
        article.handle
      );

      const img = articleWrapper.querySelector('.kw-article-card__media > img');

      if (article.image) {
        setImageAttributes(img, article.image);
      } else {
        img.parentNode.removeChild(img);
      }

      const date = new Date(article.publishedAt);
      const dateStr = date.getMonth() + 1 + '/' + date.getFullYear();
      articleWrapper.querySelector('.kw-article-card__date').textContent =
        dateStr;

      articleWrapper.querySelector('.kw-article-card__title').textContent =
        article.title;

      const excerpt = truncateWords(article.excerpt, 12);
      articleWrapper.querySelector('.kw-article-card__excerpt').textContent =
        excerpt;

      if (contentBlock && i === contentPos - 1) {
        wrapper.appendChild(contentBlock.firstElementChild);
        blockIndex++;
        contentBlock = contentItems[blockIndex] || null;
        contentPos = contentBlock ? parseInt(contentBlock.dataset.pos, 10) : -1;
      }

      wrapper.appendChild(articleWrapper.firstElementChild);
    }

    if (append) {
      articlesContainer.append(...wrapper.children);
    } else {
      articlesContainer.replaceChildren(...wrapper.children);
    }
  }

  async function storefrontSearch(query, tag, cursor) {
    const mergedQuery = [];

    if (tag) {
      mergedQuery.push("'" + tag + "'");
    }

    if (query) {
      mergedQuery.push(query);
    }

    const resp = await fetch(GRAPHQL_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': '0af00e041e2728a2b38ec2186799d248',
      },
      body: JSON.stringify({
        query: SEARCH_QUERY,
        variables: {
          query: mergedQuery.join(' '),
          pageSize: getPageSize(),
          cursor: cursor || null,
        },
      }),
    });

    const results = await resp.json();
    const search = results.data.search;
    const articles = search.edges.map(x => x.node);
    const totalCount = search.totalCount;
    const counter = document.querySelector('.kw-blog__results-count');
    const hasMore = search.pageInfo.hasNextPage;

    if (totalCount === 0) {
      counter.textContent = 'No matching articles';
    } else if (totalCount === 1) {
      counter.textContent = '1 Result';
    } else {
      counter.textContent = totalCount + ' Results';
    }

    renderArticles(articles, !!cursor);

    if (hasMore) {
      document.querySelector('.kw-blog__actions').classList.add('has-more');
      document
        .querySelector('.kw-blog__load-more')
        .setAttribute('data-next', search.pageInfo.endCursor);
    } else {
      document.querySelector('.kw-blog__actions').classList.remove('has-more');
    }

    document.querySelector('.kw-blog').classList.add('has-filter');
  }

  function buildURL(query, tag, page) {
    let url = getBlogURL();

    if (tag) {
      url += `/tagged/${tag}`;
    }

    if (page) {
      url += '?page=' + page;
    } else if (query) {
      url += '?q=' + encodeURIComponent(query);
    }

    return url;
  }

  function updateResults(url, replace) {
    const blog = document.querySelector('.kw-blog');
    const currentContainer = document.querySelector('.kw-blog__inner');
    const currentArticles = document.querySelector('.kw-blog__articles');
    const currentActions = document.querySelector('.kw-blog__actions');
    const currentResults = document.querySelector('.kw-blog__results-wrapper');
    const counter = document.querySelector('.kw-blog__results-count');

    $.get(url)
      .then(html => {
        const root = document.createElement('html');
        root.innerHTML = html;
        blog.classList.remove('has-no-results');

        if (url.indexOf('/tagged/') !== -1) {
          blog.classList.add('has-filter');
        } else {
          blog.classList.remove('has-filter');
        }

        if (replace) {
          const updatedContainer = root.querySelector('.kw-blog__inner');
          currentContainer.replaceChildren(...updatedContainer.children);
        } else {
          const newArticles = root.querySelector('.kw-blog__articles');
          const newActions = root.querySelector('.kw-blog__actions');
          const newResults = root.querySelector('.kw-blog__results-wrapper');

          currentArticles.insertAdjacentHTML(
            'beforeend',
            newArticles.innerHTML
          );
          currentActions.replaceChildren(...newActions.children);
          currentResults.replaceChildren(...newResults.children);
        }
      })
      .catch(err => {
        if (err.status !== 404) {
          throw err;
        }

        counter.textContent = 'No matching articles';
        blog.classList.add('has-no-results');
      });
  }

  function performSearch(filters, append) {
    let query = getQueryParam();
    let tag = getTagParam();

    if (filters.tag !== undefined) {
      tag = filters.tag;
    }

    if (filters.query !== undefined) {
      query = filters.query;
    }

    if (window.history && window.history.pushState) {
      const url = buildURL(query, tag);
      window.history.pushState({}, '', url);
    }

    if (!query) {
      const page = append ? getNextCursorOrPage() : null;
      updateResults(buildURL('', tag, page), !append);
      return;
    }

    const cursor = append === true ? getNextCursorOrPage() : null;
    storefrontSearch(query, tag, cursor);
  }

  const dropdown = document.querySelector('.kw-blog__search-dropdown');
  const input = document.querySelector('.kw-blog__search-form input');

  $('.kw-blog').on('click', '[data-action]', function (event) {
    event.preventDefault();
    const action = $(this).data('action');
    switch (action) {
      case 'clear-results':
        dropdown.value = '';
        input.value = '';
        performSearch({ query: '', tag: '' });
        break;
      case 'load-more':
        performSearch({}, true);
        break;
    }
  });

  $('.kw-blog .ui-form__clear').click(function (e) {
    e.preventDefault();
    $(this).siblings('input').val('');
    performSearch({ query: '' });
  });

  $('.kw-blog__search-form form').submit(function (e) {
    e.preventDefault();
    const query = $(this).find('input').val().trim();
    performSearch({ query: query });
  });

  if (dropdown) {
    dropdown.addEventListener('change', function (event) {
      performSearch({ tag: event.detail.value });
    });
  }

  const url = new URL(window.location.href);

  if (url.searchParams.has('q')) {
    const query = url.searchParams.get('q');
    document.querySelector('.kw-blog__search-form input').value = query;
    performSearch({ query: query });
  }
})();
